import React from 'react';
import classNames from 'classnames';

interface IIconsProps {
	classname?: string;
	name: string;
	useMaterialIcons?: boolean;
}
/**
 * Component for displaying only an icon, based on given name.
 */
export default function Icon({ classname, name, useMaterialIcons = false }: IIconsProps) {
	// Using material symbols
	if (useMaterialIcons) {
		return <span className={classNames(`material-symbols-outlined ${name} icon-only`, classname)}>{name}</span>;
	}

	// Using codebots icon
	return <span className={classNames(`icon-${name} icon-only`, classname)} />;
}
